import React, { useRef, useState } from 'react'

//interfaces
import { IRoleDropdown } from  '@/interfaces/roleDropdown';

//component
import CaretButton from  '@/components/elements/global/buttons/CaretButton'
import SelectItemList from  '@/components/elements/global/lists/SelectItemList/SelectItemList';

//hooks
import { useClickAwayClose } from  '@/components/hooks/utility/useClickAwayClose';



const RoleDropdown = ({id, setPermission, buttonContent, buttonAriaLabel, dropdownItems} : IRoleDropdown) => {  
    const dropdownRef = useRef<any>()
    const [showDropdown, setShowDropdown] = useState<boolean>(false);

    const handleBlur = (event: React.FocusEvent<HTMLDivElement>) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.relatedTarget as Node)) {
          setShowDropdown(false);
        }
    };
    
    useClickAwayClose(showDropdown, dropdownRef, () => setShowDropdown(false));

    function handleSingleItemSelectClick(index: number){
        if (index === 0) {
            setPermission(id, true)
        } else {
            setPermission(id, false);
        }
        setShowDropdown(false);
    };

    return(
        <div className="caret-dropdown" ref={dropdownRef} onBlur={handleBlur}>
            <CaretButton content={buttonContent} ariaLabel={buttonAriaLabel} onButtonClick={() => setShowDropdown(!showDropdown)}/>

            {showDropdown &&
                <SelectItemList items={dropdownItems} handleClick={handleSingleItemSelectClick} showCheckbox={true} />
            }
        </div>
    )
}

export default RoleDropdown